import React from 'react';
import PropTypes from 'prop-types';
import Translation from '../../../translation/translation';

function MissingSpeedIndex(props) {
    return (
        <span className="statusbar__missing-status">
            <Translation translationKey="catalog-missing-status-load-index-hint" />
            {' '}
            <Translation
                translationKey="catalog-missing-status-missing-speed-index"
                className="statusbar__add-information"
                onClick={props.onClick}
            />
        </span>
    );
}

MissingSpeedIndex.propTypes = {
    onClick: PropTypes.func.isRequired
};

export default MissingSpeedIndex;
